<template>
  <div class="custom-locale-control-regional-shoot-container">
    <div class="regional-shoot-control"
      v-if="layer.options.width == 5 && roleName =='管理员'"
    >
      <el-select
        v-model="sensor"
        placeholder="传感器"
        size="small"
        :options="sensorList"
        clearable
      >
        <el-option
          v-for="sensor of sensorList"
          :key="sensor"
          :label="sensor"
          :value="sensor"
        />
      </el-select>
      
      <el-select
        v-model="colorGroup"
        placeholder="色彩组合"
        size="small"
        :options="colorGroupList"
        clearable
      >
        <el-option
          v-for="color of colorGroupList"
          :key="color"
          :label="color"
          :value="color"
        />
      </el-select>
      <el-date-picker v-model="dateTime"
        size="small"
        @focus="focusFn"
        @panel-change="dateTimeChange"
        :popper-class="popperClassName"
        :cell-class-name="disableCellNameFn"
      ></el-date-picker>
      <el-button
        size="small"
        type="primary"
        icon="Search"
        :loading="searchLoad"
        @click="imageRequestFn(imageInit)"
      >
        获取预览影像
      </el-button>
      <input 
        class="regional-shoot-control-range"
        type="range" 
        id="volume" 
        min="0" 
        max="100"
        :style="{
          '--widthVal': `${rangeVal}%`,
        }"
        v-model="rangeVal"
        @input="rangeInput"
      >
    </div>
    <div class="regional-shoot-control">
      <el-date-picker v-model="dateVal"
        size="small"
      ></el-date-picker>
      <el-button
        size="small"
        type="primary"
        icon="Search"
        :loading="loadingVal"
        @click="shootingAreaFn"
      >
        获取拍摄影像源
      </el-button>
    </div>
    <div class="regional-shoot-content" v-show="dataList.length > 0">
      <el-scrollbar>
        <div class="regional-shoot-item"
          v-for="(item, index) of dataList"
          :key="index"
          @mouseover="itemMouseover(item)"
          @mouseout="itemMouseout(item)"
          @click="itemClick(item)"
          :class="{
            'regional-shoot-item-hover': item[hoverProp],
          }"
        >
          <div class="title">
            <div>{{ item['satelliteSource'] }}</div>
            <div class="tag">{{ item['SatelliteShootingResolution'] }}m</div>
          </div>
          <div class="attr">
            拍摄时间：{{ item['SatelliteShootingTime'] }}
          </div>
          <div class="attr">
            卫星名称：{{ item['SatelliteName'] }}
          </div>
          <div class="attr">
            云量：{{ item['SatelliteShootingCloudCoverage'] }}
          </div>
          <div class="attr">
            拍摄角度：{{ item['SatelliteShootingResolution'] }}
          </div>
          <el-button
            size='small'
            type='primary'
            @click.stop="createTaskFn(item)"
            :loading="item['loading']"
          >获取拍摄影像</el-button>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';

import {
  getShootingArea, applyAreaImage,
} from '@/api/RegionalShoot';
import { getImageByUIColorName, isHaveImageBySensor, } from '@/api/ShootApi';

// props
const props = defineProps({
  layer: { type: Object, },
  layerGroup: { type: Object, },
});
// emit
const emit = defineEmits([
  
]);

// console.log(props.layer);

const layerGroup = L.featureGroup().addTo(props.layerGroup),
layerGroupClose = ()=>{
  props.layerGroup.removeLayer(layerGroup);
}

const roleName = ref(localStorage.getItem('roleName'));

// api(预览影像)
import dateRequestFn from './utils/dateRequest';
const {
  sensorList, sensor, colorGroup, colorGroupList, requestDate, searchLoad,
  dateTime, disableTime, disableCellNameFn, dateTimeChangeCreate, imageRequestFn,
} = dateRequestFn(props.layer, isHaveImageBySensor, getImageByUIColorName);

const popperClassName = ref(`search-date-popper-${props.layer._leaflet_id}`); 
const dateTimeChange = dateTimeChangeCreate(popperClassName.value);

const focusFn = ()=>{
  if(disableTime.value.length == 0){
    dateTimeChange();
  }
}

const rangeVal = ref(100), rangeInput = (e)=>{
  const el = imagLayer && imagLayer.getElement();
  el && (el.style['clip-path'] = `inset(0% ${100 - rangeVal.value}% 0% 0%)`);
}
let imagLayer, imagLayerClear = ()=>{
  imagLayer && layerGroup.removeLayer(imagLayer);
  imagLayer = undefined;
} 
const imageInit = (data)=>{
  imagLayerClear();
  if(!(data.length > 0)){
    return;
  }
  const { imgUrl, time } = data.at(0);
  imagLayer = L.imageOverlay(
    imgUrl,
    props.layer.getBounds(),
    {
      imgTime: time,
    }
  ).addTo(layerGroup);
  rangeInput();
}

// 获取拍摄影像(任务)
const createTaskFn = (data)=>{
  data['loading'] = true;
  const mapId = store.getters['workBenchMapId'];
  applyAreaImage({
    ...data,
    [layerProp]: undefined,
    geom1: JSON.stringify(props.layer.toGeoJSON()['geometry']),
    geom2: JSON.stringify(data['SatelliteShootingArea']),
    mapId,
  }).then(res=>{
    if(res.data.code == 1004){
      message(res.data.msg, 1);
    }
  }).catch(err=>{
    console.log(err);
  }).finally(()=>{
    data['loading'] = false;
  });
}
const layerProp = 'layer', hoverProp = 'hover';

const itemMouseover = (item)=>{
  const layer = item[layerProp];
  layer && layerGroup.addLayer(layer);
},
itemMouseout = (item)=>{
  const layer = item[layerProp];
  if(!item[hoverProp]){
    layer && layerGroup.removeLayer(layer);
  }
}
const itemClick = (item)=>{
  const layer = item[layerProp];
  item[hoverProp] = !item[hoverProp];
  if(item[hoverProp]){
    layer && layerGroup.removeLayer(layer);
  }else{
    layer && layerGroup.addLayer(layer);
  }
}

const dataLayerInit = (list)=>{
  if(!list)return;
  let i = 0;
  const layerInit = (item)=>{
    // console.log(item);
    let layer;
    const geojsonStr = item['SatelliteShootingArea'];
    L.geoJSON(geojsonStr, {
      onEachFeature: (feature, p)=>{
        layer = p;
      }
    })
    item[layerProp] = layer;
  }
  const ricFn = (deadline)=>{
    while (deadline.timeRemaining() > 0 && list.length > i) {
      const item = list.at(i++);
      layerInit(item);
    }
    if(i == list.length){
      return
    }else{
      requestIdleCallback(ricFn);
    }
  }
  requestIdleCallback(ricFn);
}

const dateVal = ref(new Date());
// const dataList = ref([{"SatelliteName":"PNEO3","SatelliteShootingArea":{"coordinates":[[[120.58987559,31.03560789],[120.58969872,30.87994223],[120.58970586,30.87897633],[120.59023816,30.72487952],[120.59024736,30.72391878],[120.59141239,30.57042494],[120.59141926,30.56947558],[120.5918158,30.53137646],[120.77264547,30.50901858],[120.77254406,30.54681041],[120.77253675,30.54775891],[120.77253809,30.70001269],[120.77254598,30.70095699],[120.77318362,30.8537812],[120.77318327,30.85473985],[120.77455233,31.00907645],[120.58987559,31.03560789]]],"type":"Polygon"},"SatelliteShootingAngle":"31.16","SatelliteShootingResolution":"0.30","SatelliteShootingTime":"2025-10-23 10:34:40","satelliteSource":"AirBus","SatelliteShootingCloudCoverage":"63.00"},{"SatelliteName":"PNEO3","SatelliteShootingArea":{"coordinates":[[[120.72607736,31.01524451],[120.72608022,30.87734272],[120.72610286,30.87648962],[120.72695434,30.76376739],[120.90422816,30.76117585],[120.90414631,30.8730358],[120.90415035,30.87388014],[120.90501903,31.01071402],[120.72607736,31.01524451]]],"type":"Polygon"},"SatelliteShootingAngle":"25.64","SatelliteShootingResolution":"0.30","SatelliteShootingTime":"2025-10-23 10:34:09","satelliteSource":"AirBus","SatelliteShootingCloudCoverage":"60.00"},{"SatelliteName":"JL1GF03D19","SatelliteShootingArea":{"coordinates":[[[120.996,30.9355],[121.167,30.9075],[121.134,30.7639],[120.963,30.7919],[120.996,30.9355]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 12:47:22","satelliteSource":"CG","SatelliteShootingCloudCoverage":"78.00"},{"SatelliteName":"JL1GF03D19","SatelliteShootingArea":{"coordinates":[[[121.025,31.0654],[121.197,31.0371],[121.164,30.8934],[120.993,30.9217],[121.025,31.0654]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 12:47:20","satelliteSource":"CG","SatelliteShootingCloudCoverage":"86.00"},{"SatelliteName":"JL1GF03D19","SatelliteShootingArea":{"coordinates":[[[121.055,31.195],[121.227,31.1667],[121.194,31.0231],[121.022,31.0513],[121.055,31.195]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 12:47:18","satelliteSource":"CG","SatelliteShootingCloudCoverage":"87.00"},{"SatelliteName":"JL1GF03D19","SatelliteShootingArea":{"coordinates":[[[121.085,31.3245],[121.257,31.2962],[121.224,31.1527],[121.052,31.181],[121.085,31.3245]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 12:47:16","satelliteSource":"CG","SatelliteShootingCloudCoverage":"94.00"},{"SatelliteName":"JL1GF03D19","SatelliteShootingArea":{"coordinates":[[[121.114,31.4541],[121.287,31.4258],[121.254,31.2823],[121.081,31.3106],[121.114,31.4541]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 12:47:14","satelliteSource":"CG","SatelliteShootingCloudCoverage":"80.00"},{"SatelliteName":"JL1GF03D19","SatelliteShootingArea":{"coordinates":[[[121.144,31.5834],[121.317,31.5554],[121.284,31.4119],[121.111,31.44],[121.144,31.5834]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 12:47:12","satelliteSource":"CG","SatelliteShootingCloudCoverage":"94.00"},{"SatelliteName":"JL1GF02B","SatelliteShootingArea":{"coordinates":[[[121.693,31.5469],[121.926,31.5084],[121.882,31.3162],[121.649,31.3547],[121.693,31.5469]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 10:17:06","satelliteSource":"CG","SatelliteShootingCloudCoverage":"54.00"},{"SatelliteName":"JL1GF02B","SatelliteShootingArea":{"coordinates":[[[121.912,31.5247],[122.141,31.4865],[122.097,31.2964],[121.868,31.3345],[121.912,31.5247]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 10:17:06","satelliteSource":"CG","SatelliteShootingCloudCoverage":"38.00"},{"SatelliteName":"JL1GF02B","SatelliteShootingArea":{"coordinates":[[[121.952,31.6961],[122.181,31.658],[122.137,31.4678],[121.908,31.506],[121.952,31.6961]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 10:17:03","satelliteSource":"CG","SatelliteShootingCloudCoverage":"46.00"},{"SatelliteName":"JL1GF02B","SatelliteShootingArea":{"coordinates":[[[121.732,31.7202],[121.966,31.6817],[121.922,31.4896],[121.688,31.528],[121.732,31.7202]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 10:17:03","satelliteSource":"CG","SatelliteShootingCloudCoverage":"49.00"},{"SatelliteName":"JL1GF02B","SatelliteShootingArea":{"coordinates":[[[121.773,31.8935],[122.007,31.855],[121.962,31.6629],[121.728,31.7013],[121.773,31.8935]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 10:17:01","satelliteSource":"CG","SatelliteShootingCloudCoverage":"55.00"},{"SatelliteName":"JL1GF02B","SatelliteShootingArea":{"coordinates":[[[121.992,31.8675],[122.222,31.8294],[122.177,31.6393],[121.948,31.6774],[121.992,31.8675]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 10:17:00","satelliteSource":"CG","SatelliteShootingCloudCoverage":"69.00"},{"SatelliteName":"JL1GF02B","SatelliteShootingArea":{"coordinates":[[[121.812,32.0668],[122.047,32.0283],[122.002,31.8362],[121.768,31.8747],[121.812,32.0668]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 10:16:58","satelliteSource":"CG","SatelliteShootingCloudCoverage":"63.00"},{"SatelliteName":"JL1GF02B","SatelliteShootingArea":{"coordinates":[[[122.032,32.0389],[122.262,32.0007],[122.217,31.8107],[121.988,31.8488],[122.032,32.0389]]],"type":"Polygon"},"SatelliteShootingAngle":"-14.88","SatelliteShootingResolution":"0.80","SatelliteShootingTime":"2025-10-23 10:16:58","satelliteSource":"CG","SatelliteShootingCloudCoverage":"70.00"},{"SatelliteName":"WorldView-2","SatelliteShootingArea":{"coordinates":[[[121.664366,31.503142],[121.664569,31.453183],[121.664766,31.403308],[121.664941,31.353567],[121.665188,31.303864],[121.665361,31.254261],[121.665565,31.204718],[121.665762,31.155258],[121.665945,31.105855],[121.666124,31.056551],[121.666328,31.007313],[121.666529,30.958124],[121.666727,30.909038],[121.666919,30.860018],[121.667123,30.811062],[121.667298,30.762174],[121.66734,30.751242],[121.890498,30.731511],[121.890546,30.74257],[121.890772,30.791157],[121.890974,30.83981],[121.891168,30.888534],[121.891393,30.937307],[121.891601,30.986188],[121.891803,31.035118],[121.892038,31.084108],[121.892282,31.133191],[121.892515,31.18233],[121.892742,31.23155],[121.892988,31.280832],[121.893207,31.330195],[121.893457,31.379611],[121.893712,31.429147],[121.893955,31.478769],[121.664366,31.503142]]],"type":"Polygon"},"SatelliteShootingAngle":"27.86","SatelliteShootingResolution":"0.58","SatelliteShootingTime":"2025-10-23 10:21:05","satelliteSource":"Maxar","SatelliteShootingCloudCoverage":"58.25"}]), loadingVal = ref(false);
const dataList = ref([]), loadingVal = ref(false);
const shootingAreaFn = ()=>{
  const date = dateVal.value,
        layer = props.layer;
  if(!date){
    message('请选择日期', 2);
    return;
  }
  loadingVal.value = true;
  const geojson = layer.toGeoJSON(),
        coordinates = JSON.stringify(geojson['geometry']['coordinates']);
  getShootingArea({
    shootingDate: dayjs(date).format('YYYY-MM-DD'),
    coordinates,
  }).then(res=>{
    if(res.data.code == 1004){
      const list = res.data.data?JSON.parse(res.data.data):[];
      dataList.value = list;
      dataLayerInit(list);
    }
    loadingVal.value = false;
  }).catch(err=>{
    loadingVal.value = false;
    console.log(err);
  });
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  // shootingAreaFn();
    dataLayerInit(dataList.value);
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  layerGroupClose();
});

</script>

<style lang='less'>
.disabled-date-cell{
  pointer-events: none;
  span{
    background-color: var(--backgroundColor_4);
    border-radius: 50%;
    color: #fff;
  }
}
.custom-locale-control-regional-shoot-container{
  .regional-shoot-control{
    .el-select, .el-date-editor, .el-button{
      margin: 0;
      width: 140px;
    }
  }
}
</style>

<style lang='less' scoped>
.custom-locale-control-regional-shoot-container{
  display: flex;
  flex-direction: column;
  gap: 5px;
  .regional-shoot-control{
    display: grid;
    grid-template-columns: repeat(2, 1fr);  /* 两个等宽列 */
    gap: 5px;
    padding: 5px;
    background-color: var(--backgroundColor_3);
    border-radius: 5px;
    .regional-shoot-control-range{
      grid-column: 1 / -1;

      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      width: 100%;
      height: 6px;
      background: linear-gradient(to right, #409eff, #409eff) 0 / var(--widthVal, 0%) 100% no-repeat, #ddd;
      border-radius: 3px;
      outline: none;

      &::-webkit-slider-thumb{
        -webkit-appearance: none;
        appearance: none;
        width: 16px;
        height: 16px;
        background: white;
        border: 2px solid #409eff;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        cursor: pointer;
        transition: 0.2s;
        z-index: 2;
      }
      &::-webkit-slider-thumb:hover{
        transform: scale(1.2);
        background: #409eff;
        border-color: white;
      }
    }
  }
  .regional-shoot-content{
    padding: 5px 0;
    height: 240px;
    :deep(.el-scrollbar){
      .el-scrollbar__view{
        display: flex;
        flex-direction: column;
        gap: 5px;
      }
      .regional-shoot-item{
        border-radius: var(--borderRadiusSize);
        padding: var(--padDefaultSize);
        backdrop-filter: blur(5px);
        cursor: pointer;
        &:hover{
          // border-color: var(--borderColor_6);
          background-color: var(--backgroundColor_21);
        }
        .title{
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 16px;
          color: var(--fontColor_24);
          .tag{
            color: var(--fontColor);
            font-size: 12px;
            padding: var(--padDefaultSize);
            border-radius: 5px;
            background-color: rgb(180, 197, 215);
          }
        }
        .attr{
          line-height: 24px;
          font-size: 16px;
          color: var(--fontColor_24);
        }
      }
      .regional-shoot-item-hover{
        background-color: var(--backgroundColor_21);
      }
    }
  }
}
</style>